export default __webpack_public_path__ + "static/media/lock.61a86897.svg";